import { connect } from 'react-redux';
import { compose, lifecycle, renderNothing, withPropsOnChange } from 'recompose';

import { getOutstanding } from '../../validated/selectors';
import { setChargeAmount } from '../reducer/chargeAmount/actions';
import { getChargeAmount } from '../reducer/chargeAmount/selectors';

/*
 * @todo don't set charge amount on runtime, set it trough middleware or something
 *       causes "Cannot update during an existing state transition"
 */
const ProductSaleChargeAmount = compose(
  connect(
    state => ({
      value: getChargeAmount(state),
      amountOwed: getOutstanding(state),
    }),
    { setChargeAmount },
  ),
  lifecycle({
    componentDidMount() {
      this.props.setChargeAmount(this.props.amountOwed);
    },
  }),
  withPropsOnChange(
    ['amountOwed'],
    (props) => {
      props.setChargeAmount(props.amountOwed);
    }
  ),
  withPropsOnChange(
    ['value'],
    (props) => {
      if (props.value > props.amountOwed) props.setChargeAmount(props.amountOwed);
    }
  ),
)(renderNothing());

export default ProductSaleChargeAmount;
